import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { generateQueryString } from "@/scripts/common/util";
import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@/styles/components/slider.css";

const pageArticle = document.querySelector(".page-article");
const form = document.querySelector(".filter-form");

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterLink = (e) => {
  e.preventDefault();

  const url = e.delegateTarget.href;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  form.reset();
  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));

  window.history.replaceState({}, "", form.action);

  updateResults();
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 24);
    pageArticle.classList.add("is-filtered");
  } else {
    pageArticle.classList.remove("is-filtered");
  }

  if (res.categoryFilters) {
    const filters = form.querySelector(".category-filters");

    if (filters) {
      filters.insertAdjacentHTML("afterend", res.categoryFilters);
      filters.remove();
    }
  }

  setupFeaturedSlider();
};

const setupFeaturedSlider = () => {
  const slider = document.querySelector(".featured-slider");

  if (slider) {
    const container = slider.querySelector(".swiper");
    const numSlides = slider.querySelectorAll(".swiper-slide").length;

    if (numSlides > 1) {
      const opts = {
        modules: [A11y, Autoplay, EffectFade, Pagination],
        autoplay: {
          delay: 6000,
          pauseOnMouseEnter: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        speed: 1000,
        pagination: {
          el: slider.querySelector(".slider-pagination"),
          clickable: true,
        },
      };

      new Swiper(container, opts);
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-form .filter-link", "click", handleFilterLink);
    delegate(".filter-form", "submit", handleFilterChange);
    delegate(".filter-form-clear", "click", handleFilterClear);
  }

  setupFeaturedSlider();
});
